import ParentCompanySection from 'features/parentCompany/sections/ParentCompanySection';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomerSection from 'features/customer/sections/CustomerSection';
import SuppliersSection from 'features/customer/sections/SuppliersSection';

type Props = {}

const IdentificationPage = (props: Props) => {
  const { t } = useTranslation("shared\\moduleNames");

  return (
    <>
      <Header title={t("customer.title")} includeBreadcrumbs />
      <ModuleContent>
        <ParentCompanySection />
        <SuppliersSection />
        <CustomerSection />
      </ModuleContent>
    </>
  )
}

export default IdentificationPage;